import { f as t } from "./function-call.js";
import { f as s } from "./function-uncurry-this.js";
import { t as e } from "./to-string.js";
import { r } from "./regexp-flags.js";
import { r as i } from "./regexp-sticky-helpers.js";
import { s as n } from "./shared.js";
import { o as a } from "./object-create.js";
import { i as o } from "./internal-state.js";
import { r as l } from "./regexp-unsupported-dot-all.js";
import { r as p } from "./regexp-unsupported-ncg.js";
var x,
  h,
  g = o.get,
  d = n("native-string-replace", String.prototype.replace),
  f = RegExp.prototype.exec,
  _m = f,
  c = s("".charAt),
  u = s("".indexOf),
  I = s("".replace),
  j = s("".slice),
  v = (h = /b*/g, t(f, x = /a/, "a"), t(f, h, "a"), 0 !== x.lastIndex || 0 !== h.lastIndex),
  y = i.BROKEN_CARET,
  E = void 0 !== /()??/.exec("")[1];
(v || E || y || l || p) && (_m = function m(s) {
  var i,
    n,
    o,
    l,
    p,
    x,
    h,
    R = g(this),
    b = e(s),
    k = R.raw;
  if (k) return k.lastIndex = this.lastIndex, i = t(_m, k, b), this.lastIndex = k.lastIndex, i;
  var A = R.groups,
    O = y && this.sticky,
    w = t(r, this),
    B = this.source,
    C = 0,
    K = b;
  if (O && (-1 === u(w = I(w, "y", ""), "g") && (w += "g"), K = j(b, this.lastIndex), this.lastIndex > 0 && (!this.multiline || this.multiline && "\n" !== c(b, this.lastIndex - 1)) && (B = "(?: " + B + ")", K = " " + K, C++), n = RegExp("^(?:" + B + ")", w)), E && (n = RegExp("^" + B + "$(?!\\s)", w)), v && (o = this.lastIndex), l = t(f, O ? n : this, K), O ? l ? (l.input = j(l.input, C), l[0] = j(l[0], C), l.index = this.lastIndex, this.lastIndex += l[0].length) : this.lastIndex = 0 : v && l && (this.lastIndex = this.global ? l.index + l[0].length : o), E && l && l.length > 1 && t(d, l[0], n, function () {
    for (p = 1; p < arguments.length - 2; p++) void 0 === arguments[p] && (l[p] = void 0);
  }), l && A) for (p = 0, l.groups = x = a(null); p < A.length; p++) x[(h = A[p])[0]] = l[h[1]];
  return l;
});
var R = _m;
export { R as r };